import BaseViewController from "./base-view-controller";
import { cancelPayPalPaymentRequest } from "../api/paypal";
import { getFieldData } from "./helpers/field-updates";
import {
  CREDIT_CARD_FIELDS,
  PAYMENT_ICONS,
  PAYPAL_VALUE,
  SHORTEN_FLOW_PAYMENT_SCREENS
} from "../utils/constants";

class PaymentScreenViewController extends BaseViewController {
  preprocessScreenData() {
    this.screen = {
      ...this.screen,
      fields: this.screen.fields.map(field => ({
        ...field,
        ...(field.name === "creditCardButton" && {
          params: `${field.params}|TDFieldOptionSecondaryAction`
        }),
        ...(field.name === "paypalButton" && {
          type: "paypalButton"
        })
      }))
    };

    const { values } = this.appData;
    const cardNumberFieldname = this.appData?.isPulse
      ? CREDIT_CARD_FIELDS.creditCardValue
      : CREDIT_CARD_FIELDS.maskedCardNumber;
    const { field, index } = getFieldData(
      this.screen.fields,
      cardNumberFieldname
    );

    const changeCardActionField = getFieldData(
      this.screen.fields,
      CREDIT_CARD_FIELDS.changeToCard
    );

    if (values.hasOwnProperty(CREDIT_CARD_FIELDS.maskedCardNumber) && field) {
      // Handle credit card text update
      const cardNumber = values[CREDIT_CARD_FIELDS.maskedCardNumber];
      const { params } = field;
      const paymentIconField = getFieldData(
        this.screen.fields,
        CREDIT_CARD_FIELDS.creditCardIcon
      );

      if (
        cardNumber === PAYPAL_VALUE &&
        paymentIconField &&
        this.screen.name === SHORTEN_FLOW_PAYMENT_SCREENS.paymentPaypalShorten
      ) {
        paymentIconField.field.image = PAYMENT_ICONS.pulsePaypal;
        field.title = "";
        field.text = "";
        field.params = params.split("|").includes(PAYPAL_VALUE)
          ? params
          : `${params}|${PAYPAL_VALUE}`;

        if (
          (!this.screen.hiddenFields[CREDIT_CARD_FIELDS.maskedCardNumber] ||
            !values.lastCardNumber) &&
          changeCardActionField?.field?.action?.value &&
          this.appData.data?.screens?.some(
            screen =>
              screen.name === SHORTEN_FLOW_PAYMENT_SCREENS.paymentNoCardShorten
          )
        ) {
          changeCardActionField.field.action.value =
            SHORTEN_FLOW_PAYMENT_SCREENS.paymentNoCardShorten;
        }
      } else {
        const paymentData = cardNumber?.includes(PAYPAL_VALUE)
          ? values.lastCardNumber
          : cardNumber;
        paymentIconField.field.image = paymentData
          ? PAYMENT_ICONS.creditCardDefault
          : null;
        if (
          Object.values(SHORTEN_FLOW_PAYMENT_SCREENS).includes(this.screen.name)
        ) {
          field.title = paymentData
            ? `${field.title.slice(0, -4)}${paymentData.slice(-4)}`
            : "";
          field.text = paymentData ?? "";
        }
        field.params = params.split("|").includes(PAYPAL_VALUE)
          ? params
              .split("|")
              .filter(param => param !== PAYPAL_VALUE)
              .join("|")
          : params;
      }
    } else if (index && index !== -1 && !this.appData?.isPulse) {
      this.screen.fields.splice(index, 1);
    }
    super.preprocessScreenData();
  }

  handleButtonClick(name, text, action, replaceHistory = 0, initialScreen) {
    const { values, handleChange } = this.appData;
    const { hiddenFields } = this.screen;

    if (name === "existingCardButton") {
      if (
        Object.values(SHORTEN_FLOW_PAYMENT_SCREENS).includes(this.screen.name)
      ) {
        const updatePaymentValue =
          this.screen.name === SHORTEN_FLOW_PAYMENT_SCREENS.paymentCardShorten
            ? {
                paypal_token: null,
                [CREDIT_CARD_FIELDS.maskedCardNumber]:
                  values[CREDIT_CARD_FIELDS.maskedCardNumber] === PAYPAL_VALUE
                    ? values.lastCardNumber ||
                      hiddenFields[CREDIT_CARD_FIELDS.maskedCardNumber]
                    : values[CREDIT_CARD_FIELDS.maskedCardNumber] ||
                      hiddenFields[CREDIT_CARD_FIELDS.maskedCardNumber]
              }
            : {
                [CREDIT_CARD_FIELDS.maskedCardNumber]:
                  values[CREDIT_CARD_FIELDS.maskedCardNumber]
              };

        handleChange(updatePaymentValue);
        this.appData.values = {
          ...values,
          ...updatePaymentValue
        };
      } else {
        this.appData.values = {
          ...values,
          ...hiddenFields,
          paypal_token: ""
        };
      }
      if (
        values.paypal_token &&
        this.screen.name !== SHORTEN_FLOW_PAYMENT_SCREENS.paymentPaypalShorten
      ) {
        cancelPayPalPaymentRequest(values.paypal_token);
      }
    }

    if (name === "creditCardButton" || name === "update_card") {
      if (values.paypal_token) {
        cancelPayPalPaymentRequest(values.paypal_token);
      }

      let cardNumber = values[CREDIT_CARD_FIELDS.maskedCardNumber] || "";
      if (
        [
          hiddenFields[CREDIT_CARD_FIELDS.maskedCardNumber],
          PAYPAL_VALUE
        ].indexOf(cardNumber) >= 0
      ) {
        cardNumber = "";
      }

      this.appData.values = {
        ...values,
        paypal_token: "",
        "cc_info.masked_card_number": cardNumber,
        existing_card: "false"
      };
    }

    super.handleButtonClick(name, text, action, replaceHistory, initialScreen);
  }

  handleValuesChange(values) {
    this.appData.values = {
      ...this.appData.values,
      ...values
    };

    super.handleValuesChange(values);
  }
}

export default PaymentScreenViewController;
